<div class="h-full w-full flex flex-col relative bg-body-background text-primary-text min-h-0">

  @if (uiState() === 'idle') {
  <div
       class="flex-1 w-full h-full overflow-y-auto custom-scrollbar px-6 py-12 lg:px-12 flex flex-col items-center justify-start">

    <div class="w-full max-w-5xl mx-auto flex flex-col items-center animate-fade-in-up">
      <div class="mb-10 flex flex-col gap-4 text-center items-center mt-8">
        <i class="fas fa-sparkles text-5xl text-primary mb-2"></i>
        <h1 class="text-3xl lg:text-5xl font-extrabold text-heading tracking-tight">
          {{ config.texts.pageTitle }}
        </h1>
        <p class="text-lg text-secondary-text max-w-4xl mx-auto leading-relaxed">
          {{ config.texts.pageSubtitle }}
        </p>
      </div>

      <div class="relative w-full mb-8 group/carousel">
        <nz-carousel #suggestionsCarousel
                     [nzEffect]="'scrollx'"
                     [nzDots]="true"
                     [nzAutoPlay]="false"
                     class="w-full pb-10">
          <div nz-carousel-content
               *ngFor="let chunk of suggestionChunks()">
            <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 w-full px-2 py-2">
              @for (sugg of chunk; track sugg.title) {
              <button (click)="selectSuggestion(sugg)"
                      class="bg-component-inner border border-primary-border rounded-xl p-5 text-left hover:border-primary hover:shadow-default transition-all group flex flex-col items-start gap-2 h-[160px] overflow-hidden focus:outline-none">

                <div class="flex items-center gap-2 mb-1">
                  <i class="fad fa-sparkles text-primary opacity-70 group-hover:opacity-100 text-lg"></i>
                  <span class="font-bold text-primary-text text-base">{{ sugg.title }}</span>
                </div>

                <span class="text-sm text-secondary-text line-clamp-3 leading-relaxed">{{ sugg.description }}</span>
              </button>
              }
            </div>
          </div>
        </nz-carousel>

        <button (click)="suggestionsCarousel.pre()"
                class="absolute left-[-20px] top-1/2 -translate-y-1/2 z-10 w-10 h-10 bg-component-inner border border-secondary-border rounded-full shadow-md text-secondary-text hover:text-primary focus:outline-none transition-colors hidden md:flex items-center justify-center">
          <i class="fas fa-chevron-left"></i>
        </button>
        <button (click)="suggestionsCarousel.next()"
                class="absolute right-[-20px] top-1/2 -translate-y-1/2 z-10 w-10 h-10 bg-component-inner border border-secondary-border rounded-full shadow-md text-secondary-text hover:text-primary focus:outline-none transition-colors hidden md:flex items-center justify-center">
          <i class="fas fa-chevron-right"></i>
        </button>
      </div>

      <div
           class="w-full bg-component-inner border border-primary-border rounded-2xl p-4 shadow-sm flex flex-col gap-4 focus-within:border-primary focus-within:ring-1 focus-within:ring-primary transition-all">
        <textarea nz-input
                  [nzAutosize]="{ minRows: 4, maxRows: 12 }"
                  [ngModel]="promptText()"
                  (ngModelChange)="promptText.set($event)"
                  [placeholder]="config.texts.promptPlaceholder"
                  class="w-full !bg-transparent !border-none !shadow-none !px-2 !py-2 text-xl text-primary-text resize-none focus:outline-none custom-scrollbar"></textarea>

        <div class="flex items-center justify-between border-t border-secondary-border pt-4 px-2">

          <nz-upload [nzBeforeUpload]="beforeUpload"
                     [nzMultiple]="true"
                     [nzShowUploadList]="true"
                     class="flex-1">
            <button nz-button
                    nzType="default"
                    class="!bg-alt-background !border-secondary-border !text-secondary-text hover:!text-primary hover:!border-primary flex items-center gap-2 !rounded-lg !px-4">
              <i class="fas fa-paperclip"></i> {{ config.texts.uploadButton }}
            </button>
          </nz-upload>

          <button (click)="generateModels()"
                  [disabled]="!promptText().trim()"
                  class="bg-primary hover:bg-hover-primary text-primary-button-text font-bold rounded-lg px-8 py-2.5 transition-colors shadow-default disabled:opacity-50 disabled:cursor-not-allowed flex items-center gap-2">
            <i class="fas fa-magic"></i> {{ config.texts.generateButton }}
          </button>

        </div>
      </div>

    </div>
  </div>
  }

  @if (uiState() === 'loading' || uiState() === 'updating') {
  <div class="flex-1 flex flex-col items-center justify-center p-12 text-center animate-fade-in-up w-full h-full">
    <div class="relative w-24 h-24 flex items-center justify-center mb-8">
      <div class="absolute inset-0 border-4 border-secondary-border rounded-full"></div>
      <div class="absolute inset-0 border-4 border-primary rounded-full border-t-transparent animate-spin"></div>
      <i class="fas fa-robot text-3xl text-primary animate-pulse"></i>
    </div>
    <h2 class="text-2xl font-bold text-heading mb-3">{{ config.texts.loadingTitle }}</h2>
    <p class="text-secondary-text max-w-md">{{ config.texts.loadingDescription }}</p>
  </div>
  }

  @if (uiState() === 'preview') {
  <div class="flex-1 flex flex-col relative min-h-0 w-full h-full overflow-hidden">
    <rapider-data-templates-preview [previewData]="originalDefinition()"
                                    [hideActions]="false"
                                    [hideBackButton]="true"
                                    class="flex-1 h-full w-full"></rapider-data-templates-preview>
  </div>
  }

  @if (uiState() === 'split') {
  <div class="flex-1 flex flex-col min-h-0 w-full h-full bg-body-background overflow-hidden">

    <div
         class="h-16 shrink-0 bg-component-header border-b border-primary-border flex items-center justify-between px-6 shadow-sm z-20">
      <div class="flex items-center gap-3">
        <i class="fas fa-code-compare text-primary text-xl"></i>
        <h2 class="text-lg font-bold text-heading tracking-tight">Review AI Updates</h2>
      </div>
      <div class="flex items-center gap-3">
        <button (click)="discardUpdates()"
                class="bg-button-bg text-danger border border-danger/30 hover:bg-danger hover:text-white font-semibold rounded-lg px-6 py-2 transition-colors shadow-sm">
          {{ config.texts.discardUpdatesButton }}
        </button>
        <button (click)="saveUpdates()"
                class="bg-primary hover:bg-hover-primary text-primary-button-text font-bold rounded-lg px-8 py-2 transition-colors shadow-default">
          {{ config.texts.saveUpdatesButton }}
        </button>
      </div>
    </div>

    <nz-splitter class="flex-1 h-full min-h-0 w-full bg-body-background">

      <nz-splitter-panel class="h-full flex flex-col min-h-0 relative bg-component-inner">
        <div
             class="absolute top-0 inset-x-0 h-10 bg-alt-bold-background border-b border-primary-border flex items-center justify-center z-10 shadow-sm">
          <span class="text-sm font-bold text-secondary-text uppercase tracking-wider">{{ config.texts.originalVersion
            }}</span>
        </div>
        <div class="pt-10 flex-1 overflow-hidden h-full">
          <rapider-data-templates-preview [previewData]="originalDefinition()"
                                          [hideActions]="true"
                                          class="h-full w-full"></rapider-data-templates-preview>
        </div>
      </nz-splitter-panel>

      <nz-splitter-panel
                         class="h-full flex flex-col min-h-0 relative border-l border-primary-border bg-component-inner">
        <div
             class="absolute top-0 inset-x-0 h-10 bg-primary/10 border-b border-primary/20 flex items-center justify-center z-10 shadow-sm">
          <span class="text-sm font-bold text-primary uppercase tracking-wider"><i class="fas fa-sparkles mr-2"></i>{{
            config.texts.updatedVersion }}</span>
        </div>
        <div class="pt-10 flex-1 overflow-hidden h-full">
          <rapider-data-templates-preview [previewData]="updatedDefinition()"
                                          [hideActions]="true"
                                          class="h-full w-full"></rapider-data-templates-preview>
        </div>
      </nz-splitter-panel>

    </nz-splitter>
  </div>
  }

  @if (uiState() === 'preview' || uiState() === 'split') {
  <button nz-popover
          [nzPopoverContent]="chatPopoverContent"
          [nzPopoverTitle]="config.texts.updateTitle"
          nzPopoverPlacement="leftBottom"
          nzPopoverTrigger="click"
          [nzPopoverVisible]="isChatVisible()"
          (nzPopoverVisibleChange)="isChatVisible.set($event)"
          class="absolute bottom-8 right-8 w-14 h-14 bg-primary text-primary-button-text rounded-full shadow-thick hover:scale-105 transition-transform flex items-center justify-center z-50 focus:outline-none focus:ring-4 focus:ring-focus-ring">
    <i class="fas fa-comment-dots text-2xl"></i>
  </button>

  <ng-template #chatPopoverContent>
    <div class="flex flex-col gap-4 w-[350px] max-w-[90vw] p-2">
      <p class="text-secondary-text text-sm">{{ config.texts.updateDescription }}</p>

      <textarea nz-input
                rows="4"
                [ngModel]="chatPromptText()"
                (ngModelChange)="chatPromptText.set($event)"
                placeholder="e.g., Change the User model to include a new Date of Birth field..."
                class="w-full bg-input-background border-secondary-border focus:ring-focus-ring text-primary-text rounded-lg resize-y custom-scrollbar"></textarea>

      <nz-upload [nzBeforeUpload]="beforeChatUpload"
                 [nzMultiple]="true"
                 [nzShowUploadList]="true">
        <button nz-button
                nzType="default"
                class="!bg-alt-background !border-secondary-border !text-secondary-text hover:!text-primary hover:!border-primary flex items-center gap-2 !rounded-lg">
          <i class="fas fa-paperclip"></i> {{ config.texts.uploadButton }}
        </button>
      </nz-upload>

      <div class="flex justify-end gap-2 mt-2">
        <button nz-button
                nzType="default"
                (click)="closeChat()"
                class="!border-secondary-border !text-secondary-text !bg-button-bg hover:!bg-hover-default">Cancel</button>
        <button nz-button
                nzType="primary"
                (click)="sendUpdatePrompt()"
                [disabled]="!chatPromptText().trim()"
                class="!bg-primary !border-primary hover:!bg-hover-primary font-semibold">
          <i class="fas fa-paper-plane mr-2"></i> {{ config.texts.sendUpdateButton }}
        </button>
      </div>
    </div>
  </ng-template>
  }

</div>